// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Order_componentWrapper__h8ev1","company":"Order_company__PqYci","title":"Order_title__buxYE","label":"Order_label__NywPg"};